// extracted by mini-css-extract-plugin
export default {"header":"Centered_header__CbN1r","title":"Centered_title__Gcs14","main":"Centered_main__c1G0k"};